import { ReactNode, useCallback, useRef } from 'react'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'

export type FileUploadProps = {
  /** File input accept attribute */
  accept?: string
  label?: string
  onChange?: (file: File) => void
  helper?: ReactNode | string
}

export const FileUpload = ({
  onChange,
  accept = 'image/*',
  label = 'Choose an image',
  helper = 'The file size limit is 10MB.',
}: FileUploadProps) => {
  const hiddenFileInput = useRef<HTMLInputElement>()

  const _onChange = useCallback(
    event => {
      const file = event.target.files?.[0]
      onChange?.(file)
    },
    [onChange],
  )

  return (
    <div className="flex flex-col items-center justify-center w-96 max-w-full pt-10 mx-auto">
      <Button
        onClick={() => {
          hiddenFileInput.current.click()
        }}
      >
        {label}
      </Button>
      <input
        type="file"
        className="hidden"
        ref={hiddenFileInput}
        onChange={_onChange}
        accept={accept}
        hidden
      />
      <FormControl.HelperText className="mt-3 text-center">
        {helper}
      </FormControl.HelperText>
    </div>
  )
}
